import React,{useState} from "react";
import styled from "styled-components";
import useStatus from "../../Hooks/useStatus";
import realtimeDB from "../../Utils/api";

const ContainerTextBox=styled.div`
justify-self:end;
@media screen and (max-width:650px)
{
    justify-self:center;
}`;

const ComboBox=styled.select`
padding:15px;
border-radius:7.5px;

&:focus
{
    outline:none;
}`;

const Option=styled.option`
color:white;`;


const SwitchState=()=>
{
    const {Status,StatusColor}=useStatus();

    const Opciones=
    [
        {Nombre:"ACTIVADA",Color:"green"},{Nombre:"DESACTIVADA",Color:"red"},{Nombre:"VEREDA Y TERRAZA",Color:"orange"},{Nombre:"CIERRE",Color:"red"},{Nombre:"PAPEL Y LAPIZ",Color:"#F7A940"}
    ];

    const handleChangeInput= e =>
    {
        const Opcion=Opciones.find(opcion => opcion.Nombre===e.target.value);  
        realtimeDB.ref("/ConfigList").update
        ({
            Status:e.target.value,
            StatusColor:Opcion.Color
        });
    }

    return <ContainerTextBox>
        <ComboBox value={Status} onChange={handleChangeInput} style={{color:"white",backgroundColor:StatusColor,fontWeight:"bold"}}>
        {Opciones.map((opcion) => <Option key={opcion.Nombre} style={{backgroundColor:opcion.Color}}>{opcion.Nombre}</Option>)}
    </ComboBox>
    </ContainerTextBox>
}

export default SwitchState;
